module.exports = __webpack_public_path__ + "img/moments-empty.f1efbe72.png";